/** O bairro como a taxa compara (sem acento, minúsculas, sem espaço nas pontas), igual ao servidor (delivery.ts e
 *  orders.ts): o checkout casa a escolha com a lista e a pesquisa de bairros procura com ele. */
export function normalizeNeighborhood(s: string): string {
  return (s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}
